import React, { useState } from 'react';

const Leaderboard = ({ city, scores, userRank }) => {
  const [today] = useState(new Date().toLocaleDateString('tr-TR'));

  const getMedalIcon = (rank) => {
    switch (rank) {
      case 1:
        return '🥇';
      case 2:
        return '🥈';
      case 3:
        return '🥉';
      default:
        return null;
    }
  };

  const getRankClass = (rank) => {
    if (rank === 1) return 'rank-1';
    if (rank === 2) return 'rank-2';
    if (rank === 3) return 'rank-3';
    return '';
  };

  return (
    <div className="leaderboard">
      <div className="leaderboard-header">
        <h2 className="leaderboard-title">🏆 {city} Liderlik Tablosu</h2>
        <div className="leaderboard-date">📅 {today}</div>
      </div>

      {scores.length === 0 ? (
        <div className="no-scores">
          <div className="no-scores-icon">🎮</div>
          <p>Henüz kimse oynamadı!</p>
          <p className="no-scores-subtitle">İlk sen ol ve lider olma şansını yakala!</p>
        </div>
      ) : (
        <>
          <div className="scores-list">
            {scores.map((entry, index) => {
              const medal = getMedalIcon(entry.rank);
              const rankClass = getRankClass(entry.rank);

              return (
                <div key={index} className={`score-entry ${rankClass}`}>
                  <div className="score-rank">
                    {medal ? (
                      <span className="medal">{medal}</span>
                    ) : (
                      <span className="rank-number">#{entry.rank}</span>
                    )}
                  </div>
                  <div className="score-info">
                    <span className="score-name">{entry.display_name}</span>
                  </div>
                  <div className="score-points">
                    <span className="score-value">{entry.score}</span>
                    <span className="score-label">puan</span>
                  </div>
                </div>
              );
            })}
          </div>

          {userRank && (
            <div className="user-rank-section">
              <div className="user-rank-divider">
                <span>Senin Sıralaman</span>
              </div>
              <div className={`score-entry user-entry ${getRankClass(userRank.rank)}`}>
                <div className="score-rank">
                  {getMedalIcon(userRank.rank) ? (
                    <span className="medal">{getMedalIcon(userRank.rank)}</span>
                  ) : (
                    <span className="rank-number">#{userRank.rank}</span>
                  )}
                </div>
                <div className="score-info">
                  <span className="score-name">Sen ({userRank.display_name})</span>
                </div>
                <div className="score-points">
                  <span className="score-value">{userRank.score}</span>
                  <span className="score-label">puan</span>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Leaderboard;